import { render, staticRenderFns } from "./ParticipantsModule.vue?vue&type=template&id=56602f76"
import script from "./ParticipantsModule.vue?vue&type=script&lang=ts"
export * from "./ParticipantsModule.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports